import { ReactNode } from 'react';

import UnauthorizedPage from '@occc-app/routes/Unauthorized';

import { useRetailerNetworkUserSelector } from '../retailer-network-context/use-retailer-network-user.selector';

export type RetailerNetworkSiteUserRoleGuardProps = {
  fallback?: ReactNode;
  children: ReactNode;
};

export const RetailerNetworkViewGuard = ({
  children,
  fallback,
}: RetailerNetworkSiteUserRoleGuardProps) => {
  const { isRetailerNetworkSiteUserRole } = useRetailerNetworkUserSelector();

  if (isRetailerNetworkSiteUserRole) {
    return fallback ? fallback : <UnauthorizedPage />;
  }

  return children;
};
